function video() {
if (document.querySelector('.ecocabin-offer__video-wrap')) {

    const videoBlock = document.querySelector('.ecocabin-offer__video-wrap');
    const videoPlayToggle = document.querySelector('.ecocabin-offer__video--toggle');
    const video = document.querySelector('.ecocabin-offer__video');

    videoBlock.addEventListener('click', videoToggle);

    function videoToggle() {
        if (video.paused) {
            video.play();
            videoPlayToggle.style.display = 'none';
        } else {
            video.pause();
            videoPlayToggle.style.display = 'block';
        }
    }
}
}
module.exports = video;